import { CartItemFragment } from '@/features/graphql/generated/graphql'
import {
    AddonGroupDefaults,
    ProductVariantDefaults,
    RemovableIngredientDefaults,
} from '@/features/pos/components/ProductConfigurationModal/types'

const getToppingAddonDefaults = (cartItem: CartItemFragment): AddonGroupDefaults =>
    cartItem.toppingGroupToppings.reduce<AddonGroupDefaults>((defaults, toppingGroupTopping) => {
        const toppingGroupId = toppingGroupTopping.toppingGroup.uuid

        defaults[toppingGroupId] ??= {}
        defaults[toppingGroupId][toppingGroupTopping.topping.uuid] = toppingGroupTopping.quantity

        return defaults
    }, {})

const getAdditionProductAddonDefaults = (cartItem: CartItemFragment): AddonGroupDefaults =>
    cartItem.additionGroupProductVariants.reduce<AddonGroupDefaults>(
        (defaults, additionGroupProduct) => {
            const additionGroupId = additionGroupProduct.additionGroup.uuid

            defaults[additionGroupId] ??= {}
            defaults[additionGroupId][additionGroupProduct.productVariant.uuid] =
                additionGroupProduct.quantity

            return defaults
        },
        {}
    )

const getRemovableIngredientDefaults = (cartItem: CartItemFragment): RemovableIngredientDefaults =>
    cartItem.removedRecipeIngredients.reduce<RemovableIngredientDefaults>(
        (defaults, ingredient) => {
            defaults[ingredient.uuid] = true

            return defaults
        },
        {}
    )

export const getProductVariantDefaults = (cartItem: CartItemFragment): ProductVariantDefaults => ({
    toppings: getToppingAddonDefaults(cartItem),
    additionProducts: getAdditionProductAddonDefaults(cartItem),
    removableIngredients: getRemovableIngredientDefaults(cartItem),
})
